export default function (url) {
   return url.split('/').pop()
}